import { render, staticRenderFns } from "./iframeGame.vue?vue&type=template&id=3b6b4a02&scoped=true"
import script from "./iframeGame.vue?vue&type=script&lang=js"
export * from "./iframeGame.vue?vue&type=script&lang=js"
import style0 from "./iframeGame.vue?vue&type=style&index=0&id=3b6b4a02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6b4a02",
  null
  
)

export default component.exports